import styled from 'styled-components'
import { FlexContainer } from '../../components/Layout/Page'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: ${({ theme }) => 4 * theme.unit}px;
`
Container.displayName = 'Container'

const VetDecHeader = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.unit}px;
  background-color: ${({ theme }) => theme.palette.nswBrandDark};
  color: ${({ theme }) => theme.palette.nswTextLight};
  display: flex;
  flex-direction: column;
`
VetDecHeader.displayName = 'VetDecHeader'

const HeaderHeading = styled.div`
  font-size: 1.4rem;
`

const HeaderSubHeading = styled.div`
  font-size: 1rem;
`

export default function VetDecPage({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <FlexContainer className="fa-page__vet-dec">
      <Container>
        <VetDecHeader>
          <HeaderHeading>Cattle Tick Record Of Movement</HeaderHeading>
          <HeaderSubHeading>Vet Declaration</HeaderSubHeading>
        </VetDecHeader>
        {children}
      </Container>
    </FlexContainer>
  )
}
